import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { Observable } from "rxjs";
import { RuleAlert } from "src/app/models/rule-alert.model";
import { IRuleAlertsInfosParams, RuleAlertService } from "src/app/providers/rule-alert.service";

export class AlertListDataSource extends MatTableDataSourceBackendExtended<RuleAlert> {
  constructor(private ruleAlertService: RuleAlertService) {
    super();
  }

  public data(params: IRuleAlertsInfosParams): Observable<RuleAlert[]> {
    return this.ruleAlertService.listInfos(params);
  }

  protected dataCount(params: IRuleAlertsInfosParams): Observable<number> {
    return this.ruleAlertService.countInfos(params);
  }
}
